var _rect, _path, _line, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.6404,
    y: 28.3631,
    width: 32.5018,
    height: 18.0869,
    fill: "#328CE1",
    stroke: "#166BCD",
    strokeWidth: 1.1012,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8027 16.3313L15.9917 27.7481L31.8913 40.004L47.7909 27.7481L32.9799 16.3313C32.3384 15.8368 31.4442 15.8368 30.8027 16.3313ZM47.9903 27.9018L47.9897 27.9013L47.9903 27.9018Z",
    fill: "#328CE1",
    stroke: "#166BCD",
    strokeWidth: 1.1012,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.5,
    x1: 19.3445,
    y1: 28.3517,
    x2: 44.6721,
    y2: 28.3517,
    stroke: "#166BCD",
    strokeWidth: 1.1012,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14186_170576",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 12,
    width: 36,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8593 39.4228L14.3896 25.798V12.9355H49.0427L49.4274 25.798L31.8593 39.4228Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14186_170576)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.9971,
    y: 14.5879,
    width: 22.0239,
    height: 27.5299,
    rx: 1.1012,
    fill: "white",
    stroke: "#7EB3F1",
    strokeWidth: 1.1012,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5769,
    y1: 19.7288,
    x2: 31.7346,
    y2: 19.7288,
    stroke: "#166BCD",
    strokeWidth: 1.65179,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.3016,
    y1: 23.8654,
    x2: 39.4171,
    y2: 23.8654,
    stroke: "#328CE1",
    strokeWidth: 1.1012,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.3016,
    y1: 26.8928,
    x2: 39.4171,
    y2: 26.8928,
    stroke: "#328CE1",
    strokeWidth: 1.1012,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.3016,
    y1: 29.9221,
    x2: 39.4171,
    y2: 29.9221,
    stroke: "#328CE1",
    strokeWidth: 1.1012,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.0047,
    y1: 32.9494,
    x2: 35.7131,
    y2: 32.9494,
    stroke: "#328CE1",
    strokeWidth: 1.1012,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8031 36.8547L16.3821 46.3892C16.3721 46.3958 16.3687 46.4003 16.3682 46.401C16.3675 46.4018 16.3674 46.4021 16.3673 46.4026C16.3667 46.4045 16.3649 46.413 16.3688 46.426C16.3727 46.439 16.3789 46.4452 16.3804 46.4464C16.3809 46.4468 16.3811 46.447 16.3821 46.4473C16.3829 46.4476 16.3882 46.4494 16.4002 46.4494H47.1727C47.1848 46.4494 47.1901 46.4476 47.1909 46.4473C47.1914 46.4471 47.1917 46.447 47.192 46.4468C47.1922 46.4467 47.1923 46.4466 47.1925 46.4464C47.194 46.4452 47.2003 46.439 47.2042 46.426C47.2081 46.413 47.2063 46.4045 47.2057 46.4026C47.2056 46.4024 47.2056 46.4022 47.2054 46.4019C47.2053 46.4017 47.2051 46.4014 47.2048 46.401C47.2043 46.4003 47.2009 46.3958 47.1908 46.3892L32.7699 36.8547C32.1736 36.4604 31.3994 36.4604 30.8031 36.8547Z",
    fill: "#166BCD",
    stroke: "#166BCD",
    strokeWidth: 1.1012,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.6e58b999c751b46783f55adc30f5d538.svg";
export { ForwardRef as ReactComponent };